import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {
  PatientAppointmentsRepositoryService,
  AppointmentNotification,
  AppointmentNotificationTypeLabels,
  AppointmentNotificationStatusLabels,
  AppointmentNotificationType,
  AppointmentNotificationStatus
} from '@xmedical/core';
import {DatePipe} from '@angular/common';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {XmedicalUiModule} from '@xmedical/ui';

export interface AppointmentNotificationLogDialogData {
  appointmentId: number;
}

@Component({
  selector: 'app-appointment-notification-log',
  templateUrl: './appointment-notification-log.component.html',
  styleUrls: ['./appointment-notification-log.component.scss'],
  imports: [
    DatePipe,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    XmedicalUiModule,
  ]
})
export class AppointmentNotificationLogComponent implements OnInit, OnDestroy {

  notifications: AppointmentNotification[] = [];
  loading = true;
  displayedColumns = ['notificationType', 'status', 'recipientEmail', 'scheduledSendTime', 'sentTime', 'subject', 'result'];

  private subscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<AppointmentNotificationLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppointmentNotificationLogDialogData,
    private appointmentsRepository: PatientAppointmentsRepositoryService
  ) {}

  ngOnInit(): void {
    this.subscription = this.appointmentsRepository.loadAppointmentNotifications(this.data.appointmentId).subscribe({
      next: (notifications) => {
        this.notifications = notifications;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading notification log', error);
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  getTypeLabel(type: AppointmentNotificationType): string {
    return AppointmentNotificationTypeLabels[type] ?? 'Unknown';
  }

  getStatusLabel(status: AppointmentNotificationStatus): string {
    return AppointmentNotificationStatusLabels[status] ?? 'Unknown';
  }

  close() {
    this.dialogRef.close();
  }
}
